export default [
  {
    title: 'breadcrumb.baccaratBalanceReport',
    route: 'baccarat-balance-report',
    icon: '',
    resource: 'baccarat-balance-report',
    action: 'read'
  }
];